module.exports = __webpack_public_path__ + "static/media/md-clock.413c314a.svg";